export default "__VITE_ASSET__CsYyoeOl__"